import _sfc_main from "./index.vue2.mjs";
/* empty css            */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "localScreenContainerRef", staticClass: "local-screen-container" }, [_c("div", { class: ["local-screen-control-container", { mini: _setup.isMiniRegion }] }, [_c("div", { staticClass: "local-screen-info" }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.ScreenSharingIcon } }), _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_setup.t("You are sharing the screen...")))])], 1), _c(_setup.TuiButton, { staticClass: "stop-button", attrs: { "size": "default" }, on: { "click": _setup.openStopConfirmDialog } }, [_vm._v(" " + _vm._s(_setup.t("End sharing")) + " ")]), _c(_setup.Dialog, { attrs: { "width": "420px", "title": _setup.t("End sharing"), "modal": true, "close-on-click-modal": true, "append-to-room-container": true }, scopedSlots: _vm._u([{ key: "footer", fn: function() {
    return [_c("span", [_c(_setup.TuiButton, { staticClass: "dialog-button", attrs: { "size": "default" }, on: { "click": _setup.stopScreenSharing } }, [_vm._v(" " + _vm._s(_setup.t("End sharing")) + " ")]), _c(_setup.TuiButton, { attrs: { "type": "primary", "size": "default" }, on: { "click": function($event) {
      _setup.showStopShareRegion = false;
    } } }, [_vm._v(" " + _vm._s(_setup.t("Cancel")) + " ")])], 1)];
  }, proxy: true }]), model: { value: _setup.showStopShareRegion, callback: function($$v) {
    _setup.showStopShareRegion = $$v;
  }, expression: "showStopShareRegion" } }, [_c("span", [_vm._v(" " + _vm._s(_setup.t("Others will no longer see your screen after you stop sharing. Are you sure you want to stop?")) + " ")])])], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a9890977"
);
const LocalScreenView = __component__.exports;
export {
  LocalScreenView as default
};
